// services/api/chatbot/chatbot-session.service.ts
import axios from "axios";

const GPT_URL = "https://gpt.seliseblocks.com";
const PROJECT_KEY = process.env.EXPO_PUBLIC_X_BLOCKS_KEY as string;
const BLOCKS_AI_URL = process.env.EXPO_PUBLIC_BLOCKS_BASE_URL;

export const initiateSession = async (widgetId: string) => {
  const res = await axios.post(`${GPT_URL}/api/initiate`, {
    widget_id: widgetId,
    project_key: PROJECT_KEY,
  });
  return res.data as { session_id: string; token: string; expires_at: string };
};

export const sendChatMessage = async (
  sessionId: string,
  token: string,
  message: string,
  onChunk: (chunk: string) => void,
) => {
  const response = await fetch(
    `${BLOCKS_AI_URL}/blocksai-api/v1/chat/${sessionId}?project_key=${PROJECT_KEY}&pg=true`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-blocks-token": token,
        "x-blocks-key": PROJECT_KEY,
      },
      body: JSON.stringify({ message }),
    },
  );

  const reader = response.body?.getReader();

  // React Native's fetch does not expose a readable stream body
  // (`response.body` is undefined), so `getReader()` is unavailable. In that
  // case read the full response text once and parse all SSE events — the reply
  // appears at once instead of token-by-token, but it actually displays.
  // Browsers keep the incremental streaming path.
  if (!reader) {
    const text = await response.text();
    parseSseEvents(text, onChunk);
    return;
  }

  const decoder = new TextDecoder();
  while (true) {
    const { done, value } = await reader.read();
    if (done) break;
    parseSseEvents(decoder.decode(value), onChunk);
  }
};

// Parse SSE-formatted text (event:/data: line pairs) and emit each
// `chat_response` message via onChunk. Shared by the streaming (web) and
// full-text (React Native) paths.
const parseSseEvents = (text: string, onChunk: (chunk: string) => void) => {
  const lines = text.split("\n").filter((l) => l.trim());
  let currentEvent = "";
  for (const line of lines) {
    if (line.startsWith("event:")) {
      currentEvent = line.replace("event:", "").trim();
      continue;
    }
    if (line.startsWith("data:")) {
      try {
        const data = JSON.parse(line.replace("data:", "").trim());
        if (currentEvent === "chat_response" && data.message) {
          onChunk(data.message);
        }
      } catch {}
    }
  }
};
